import { notification } from "antdv-next";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

import router from "@/router/index.js";
import { useUserStore } from "@/store/modules/user.js";
import { useCardTemplatesStore } from "@/store/modules/cardTemplates.js";
import { canAccessActionRoute } from "./actionRoutePermission.mjs";

NProgress.configure({ showSpinner: false });

function getMatchedRoutePaths(to) {
  return (to.matched || []).map((record) => record.path).filter(Boolean);
}

function hasRoutePermission(to) {
  if (to.name === "signIn" || to.meta?.hideNav) {
    return true;
  }
  const userStore = useUserStore();
  if (to.meta?.requiredActionPermission) {
    return canAccessActionRoute(to.meta, userStore);
  }
  const pagePermissions = userStore.pagePermissions || [];
  if (!pagePermissions.length) {
    return false;
  }
  const matchedPaths = getMatchedRoutePaths(to);
  return matchedPaths.some((path) => pagePermissions.includes(path));
}

function redirectWithoutPermission(next) {
  const userStore = useUserStore();
  const perms = userStore.pagePermissions || [];
  if (!perms.length) {
    notification.error({
      message: "无此权限",
      description: "您无此访问权限"
    });
    next({ path: "/users/sign_in" });
    return;
  }
  notification.error({
    message: "无此权限",
    description: "您无此访问权限"
  });
  next({ path: perms[0] });
}

async function preloadCardTemplates() {
  try {
    await useCardTemplatesStore().getCardTemplates();
  } catch {
    // 模板预加载失败不阻断路由权限流程。
  }
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  if (to.name === "signIn") {
    if ((useUserStore().pagePermissions || []).length) {
      next({ path: "/" });
      return;
    }
    next();
    return;
  }

  const ensurePermission = () => {
    if (hasRoutePermission(to)) {
      next();
      return;
    }
    redirectWithoutPermission(next);
  };

  const userStore = useUserStore();
  const pagePerms = userStore.pagePermissions || [];
  if (!pagePerms.length) {
    if (!userStore.profileLoaded) {
      try {
        await userStore.getInfo();
        ensurePermission();
      } catch {
        next({ path: "/users/sign_in" });
      }
      preloadCardTemplates();
      return;
    }
    notification.error({
      message: "无此权限",
      description: "您无此访问权限"
    });
    next({ path: "/users/sign_in" });
    return;
  }

  ensurePermission();
});

router.afterEach(() => {
  NProgress.done();
});

router.onError(() => {
  NProgress.done(true);
});
